import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "./shopMapPreview.css"

// Fix default marker icon (Leaflet quirk)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
	iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
	shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;



const ShopMapPreview = ({ lat, lng }) => {
	if (!lat || !lng) return null;

    const previewMarkerIcon = L.divIcon({
	className: "sf-marker",
	html: `
		<div class="sf-marker-inner no-rating">
			<svg width="36" height="48" viewBox="0 0 36 48" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18 0C8.1 0 0 8.1 0 18c0 13.5 18 30 18 30s18-16.5 18-30C36 8.1 27.9 0 18 0z"
					fill="#111"
				/>
			</svg>
		</div>
	`,
	iconSize: [36, 48],
	iconAnchor: [18, 48],
});

	return (
		<MapContainer
			center={[lat, lng]}
			zoom={15}
			style={{ height: 200, width: "100%", borderRadius: 12 }}
			zoomControl={false}
			dragging={false}
			scrollWheelZoom={false}
			attributionControl={false}
		>
			<TileLayer
				url={`https://api.mapbox.com/styles/v1/iwhite/cmjwicu52001001qo18qxh9i4/tiles/512/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`}
				tileSize={512}
				zoomOffset={-1}
			/>

			<Marker
				position={[lat, lng]}
				icon={previewMarkerIcon}
			/>
		</MapContainer>
	);
};


export default ShopMapPreview;
